export type PrizmTimeFormatParts = 'HH' | 'MM' | 'SS' | 'MS';
